import React, { useState, useEffect } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

import Item from './Item';
import { getVideos } from '../api/api';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: '30px 0px'
  },
  seeAll: {
    padding: '20px 60px'
  },
  centered: {
      marginTop: 30,
      textAlign: 'center',
      width: '100%'
  },
  loading: {
    display: 'flex',
    justifyContent: 'center',
    padding: '50px 0'
  }
}));

const Videos = () => {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const response = await getVideos();
        const mappedVideos = response.items.map(item => ({
          id: item.id,
          url: item.link,
          description: item.description,
          caption: item.description
        }));
        setVideos(mappedVideos);
        setLoading(false);
      } catch (err) {
        console.error('Failed to load videos:', err);
        setLoading(false);
      }
    };

    fetchVideos();
  }, []);

  const seeAll = () => {
      window.open('https://www.youtube.com/channel/UC0LAY5xS4QcxQXx5GdcoVOw/videos', '_blank');
  };

  const opts = {
    height: isMobile ? '285' : '405',
    width: isMobile ? '380' : '540',
    playerVars: {
      autoplay: 0,
      iv_load_policy: 3,
      loop: 1,
      rel: 0,
      modestbranding: 1,
      playlist: videos.map(v => v.url).join(',')
    }
  };

  if (loading) {
    return (
      <div className={classes.loading}>
        <CircularProgress />
      </div>
    );
  }

  return (
    <div className={classes.root}>
      <Grid
        container
        spacing={2}
        direction="row"
        alignItems="flex-start"
        justifyContent="space-around"
      >
        {videos.map(video => (
          <Item
            key={video.id}
            opts={opts}
            section={video}
            width={6}
            type="video"
          />
        ))}
      </Grid>
      <div className={classes.centered}>
        <Button className={classes.seeAll} variant="raised" color="primary" onClick={seeAll}>
          SEE ALL
        </Button>
      </div>
    </div>
  );
};

export default Videos;
